export default __webpack_public_path__ + "static/about-you-header-9de5f3d28d3019c755d671682c6645ff.png";